import { Stack, SxProps, Theme, Typography } from "@mui/material";

interface CPTitleProps {
  title: string;
  boldTitle?: string;
  hint?: string;
  className?: string;
  sx?: SxProps<Theme>;
}

export const CPTitle = ({
  title,
  boldTitle = '',
  hint,
  className,
  sx
}: CPTitleProps) => {
  return (
    <Stack className={className} spacing={2} sx={sx}>
      <Typography fontSize={24}>
        {title + " "}

        {/* 15 is hard-coded value. I cannt find better way to break word if it is too long */}
        {boldTitle.length > 15 && <br /> }

        <b>{boldTitle}</b>
      </Typography>
      {hint && <span className="cp-hint">
        {hint}
      </span>}
    </Stack>
  );
};
